import type { FC } from 'react';
import { Link } from '@compat/router';
import { Picture } from '@ui';
import { ruStore, huaStore, playStore, appleStoreNew } from '@images';
import content from './components/content';
import FooterSocialIcons from './components/FooterSocialIcons';
import QRCodeComponent from '@components/QRCode';
import {
  APP_STORE,
  GOOGLE_PLAY,
  HUAWEI_STORE,
  RUSTORE
} from '@constants/appLinks';
import FooterRating from './components/FooterRating';
import { observer } from 'mobx-react';

const currentYear = new Date().getFullYear();
interface DesktopFooterProps {
  openCallbackModal: () => void;
}

const DesktopFooter: FC<DesktopFooterProps> = observer(
  ({ openCallbackModal }) => (
    <div className='desktop-footer'>
      <div className='question'>
        <div className='main-container'>
          <b>Есть вопросы по заказу? </b> Звоните
          <a href='tel:+74956409640'>
            <b> +7 495 640 9 640 </b>
          </a>{' '}
          с 06:00 до 00:00
        </div>
      </div>
      <div className='main-container'>
        <nav className='footer-menu'>
          <div className='container'>
            <div className='menu-box'>
              <div className='header-menu'> О нас </div>
              <ul>
                {content.footerLinks.aboutUs?.map((item, index) => (
                  <li key={index}>
                    <a href={item.url}>{item.title}</a>
                  </li>
                ))}
              </ul>
            </div>

            <div className='menu-box'>
              <div className='header-menu'>Покупателям </div>
              <ul>
                {content.footerLinks.forСlients?.map((item, index) => (
                  <li key={index}>
                    <a href={item.url}>{item.title}</a>
                  </li>
                ))}
              </ul>
            </div>

            <div className='menu-box'>
              <div className='header-menu'>Контакты</div>
              <div className='contacts'>
                <address>
                  <span>140053, </span>
                  <span>Котельники г, Московская обл.</span>
                  ,
                  <br />
                  <span>Силикат мкр, строение № 4, Пом/Ком 2/6</span>
                  <br />
                </address>
                <span className='name-organization'>
                  <span>ООО «Д-Снаб»</span>
                </span>
                <div className='phone_number'>
                  <a href='tel:+74956409640'>+7 495 640 9 640</a>
                  <span className='work-time'>06:00 - 00:00</span>
                </div>
                <div className='feedback-box'>
                  <span className='callback-link'>
                    <span onClick={openCallbackModal}>Обратный звонок</span>
                  </span>

                  <span className='callback-link'>
                    <Link
                      to={{
                        pathname: '/reviews'
                      }}
                    >
                      {' '}
                      Обратная связь
                    </Link>
                  </span>
                </div>
              </div>
            </div>
          </div>

          <div className='container'>
            <div className='menu-box payment'>
              <div className='header-menu'>Способы оплаты</div>
              <ul className='payment'>
                {content.payments?.map((item, index) => (
                  <li key={index}>
                    <Picture
                      icon={item.img}
                      width={item.width}
                      height={item.height}
                      className={item.className}
                    />
                  </li>
                ))}
              </ul>
              <div className='footer-ratings-container'>
                <FooterRating type='yandex' />
                <FooterRating type='2gis' />
              </div>
            </div>

            <div className='menu-box'>
              <div className='header-menu'>Скачайте приложение</div>
              <div className='app-section'>
                <QRCodeComponent size={172} className='footer-qr' />
                <ul className='flex footer-gap-4'>
                  {[
                    {
                      id: 'appstore',
                      title: 'App Store',
                      href: APP_STORE,
                      icon: appleStoreNew
                    },
                    {
                      id: 'googlePlay',
                      title: 'Google Play',
                      href: GOOGLE_PLAY,
                      icon: playStore
                    },
                    {
                      id: 'huawei',
                      title: 'Huawei',
                      href: HUAWEI_STORE,
                      icon: huaStore
                    },
                    {
                      id: 'rustore',
                      title: 'Rustore',
                      href: RUSTORE,
                      icon: ruStore
                    }
                  ].map(item => (
                    <li key={item.id}>
                      <a href={item.href} target='_blank' rel='noreferrer'>
                        <Picture
                          icon={item.icon}
                          pictureClassName='[&>img]:sm:w-9 [&>img]:sm:h-9'
                          width='40'
                          height='40'
                          alt={item.title}
                        />
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </nav>
        <hr className='mb-8' />
        <div className='flex items-center justify-between allMd:flex-col-reverse allMd:items-start allMd:gap-6 allMd:px-6.25'>
          <div className='copyright'>
            © {currentYear} Деликатеска.ру - интернет-магазин продуктов. Все
            права защищены
          </div>
          <FooterSocialIcons isDarkGrey={false} />
        </div>
        <aside className='flex items-center justify-between pb-8 allMd:flex-col allMd:items-start allMd:gap-6 allMd:px-6.25'>
          <div>Доставка по Москве и Московской области</div>
          <div className='links'>
            <Link to='/license-agreement'>Пользовательское соглашение</Link>
            <Link to='/confidential'>Политика конфиденциальности</Link>
            <Link to='/pdn'>Согласие на обработку персональных данных</Link>
          </div>
        </aside>
      </div>
    </div>
  )
);

export default DesktopFooter;
